<template>
    <div class="dashboard">
        <loading ref="bLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="bOops"/>
            <error ref="bError"/>
            <berth-header ref="bHeader"/>
            <div class="berthDashContent">
                <berth-info ref="bInfo"/>
                <berth-vessels ref="bVessels" />
                <berth-chart-companies ref="bChartCompany"/>
            </div>
        </div>
        <bottom-credits />
    </div>
</template>

<script>
import axios from 'axios';
import BerthHeader from '../components/berths/BerthHeader.vue';
import BerthInfo from '../components/berths/BerthInfo.vue'
import BerthVessels from '../components/berths/BerthVessels.vue';
import BerthChartCompanies from '../components/berths/BerthChartCompanies.vue'
import Loading from '../components/Loading.vue';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import Oops from '../components/Oops.vue';
import Error from '../components/Error.vue';

export default {
    name: "Berths",
    components: {
        BerthHeader,
        BerthInfo,
        BerthVessels,
        BerthChartCompanies,
        Loading,
        BottomCredits,
        HeaderNavigation,
        Oops,
        Error
    },
    data: () => ({
        loadStatus: 0
    }),
    mounted() {
        var globv = this;
        globv.$refs.bLoadScreen.startLoading();
        globv.retrieveBerthData();
    },
    methods: {
        retrieveBerthData: function() {
            var globv = this;
            let berthID = globv.$route.params.berth;

            axios.get('/api/berths/' + berthID).then((response) => {
                // console.log(JSON.stringify(response, undefined, 4));

                if (response && response.data) {
                    var berth = response.data;

                    globv.$refs.bHeader.updateInfo({
                        name: berth['berthInfo']['general']['name'],
                        owner: berth['berthInfo']['general']['owners'],
                        dockID: berth['berthInfo']['general']['ID']
                    });
                    globv.$refs.bInfo.updateInfo(berth['berthInfo']);
                    globv.$refs.bVessels.updateInfo(berth['vessels']);
                    globv.$refs.bChartCompany.createChart(berth['vessels']['visited']);
                }

                globv.loadStatus += 1;
            })
            .catch(error => {
                globv.reset();
                globv.handleError(error);
            });
        },
        handleError: function(error) {
            var globv = this;
            console.log(error, error.response);
            error = error.response.data;
            if (error['error'] && error['error']['status'] < 500) {
                if (error['error']['status'] == 404)
                    globv.$refs.bError.showError({
                        status: 404, 
                        title: "Not Found", 
                        message: error['error']['message']
                    });
                else
                    globv.$refs.bError.showError({
                        status: error['error']['status'],
                        message: error['error']['message']
                    });
            }
            else
                globv.$refs.bOops.showOops();

            setTimeout(globv.$refs.bLoadScreen.finishLoading, 300);
        },
        reset: function() {
            var globv = this;

            console.log(globv.$refs);

            globv.$refs.bHeader.reset();
            globv.$refs.bInfo.reset();
            globv.$refs.bVessels.reset();
            globv.$refs.bChartCompany.reset();
        }
    },
    watch: {
        '$route.params.berth': function() {
            var globv = this;
            globv.loadStatus = 0;
            globv.$refs.bLoadScreen.startLoading();
            globv.reset();
           
            globv.retrieveBerthData();
        },
        loadStatus: function() {
            var globv = this;
            
            if (globv.loadStatus == 1) {
                setTimeout(globv.$refs.bLoadScreen.finishLoading, 300);
                globv.loadStatus = 2;
            }
        }
    }
}
</script>

<style lang="scss">
.berthDashContent {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1 0 auto;

    .chart {
        width: 100%;
    }

    > .card {
         width: 80%;
         max-width: 1200px;
    }

    .dashFlexContent {
        width: 80%;

        .chart {
            width: 400px;
        }
    }
}

@media (max-width: 1200px) {
    .berthDashContent {
        width: 98vw;

        .card {
            margin: 20px 10px;
            width: 98%;
        }

        .dashFlexContent {
            width: 100%;
        }
    }
}

@media (max-width: 900px) {
    .berthDashContent {

        .card {
            margin: 20px 0px;
            width: 100%;
        }

        .dashFlexContent {
            flex-direction: column;
            align-items: center;

            .chart {
                width: 100%;
            }
        }
    }

    .infoVerticalSpacing {
        margin-top: 0;
    }
}

@media (max-width: 755px) {
    .berthDashContent {
        padding: 0;
        width: 100%;

        .dashFlexContent {
            .chart {
                width: 90vw;
            }
        }
    }
}

@media (max-width: 500px) {
    .berthDashContent {
        width: fit-content;

        .cardContent {
            padding: 0 10px 10px;
        }
    }
}

@media (max-width: 445px) {
    .berthDashContent p {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
